export default __webpack_public_path__ + "static/media/angular.82a370c3.svg";